// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import App from './App'
import router from './router'
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "../node_modules/swiper/dist/css/swiper.css";

Vue.config.productionTip = false
Vue.use(ElementUI);

import config from './http/config.js'
import api from './http/interface.js' //引入接口文件

Vue.config.productionTip = false
// 环境判断
if(process.env.NODE_ENV === 'development'){//开发环境
  config.baseURL = '';
}else{//线上环境
  config.baseURL = '';
}

Vue.prototype.$api = api; //挂载

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  next();
});




// WEBPACK FOOTER //
// ./src/main.js